import axios from "axios";

const fetchAccessRightStructure = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/account/api/v1/access-right/structure/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) =>  reject(error.response.data));
  });
};

export default fetchAccessRightStructure;
